import { DocumentData } from '@/api/types';

export function reverseProfileDocumentDataInfoFieldsMapperWithSeriesAndNumber(formInfo: {
  [key: string]: string;
}): DocumentData['fields'] {
  const result: DocumentData['fields'] = {};

  if (formInfo.serialNumberDoc) {
    result.referenceNumber = formInfo.serialNumberDoc;
  }

  if (formInfo.date) {
    result.dateIssue = formInfo.date;
  }

  if (formInfo.auth_dep) {
    result.issue = formInfo.auth_dep;
  }

  if (formInfo.unzr) {
    result.unzr = formInfo.unzr;
  }

  if (formInfo.expirationDate) {
    result.expiredDate = formInfo.expirationDate;
  }

  if (formInfo.issueCountryIso2) {
    result.issueCountryIso2 = formInfo.issueCountryIso2;
  }

  (Object.keys(result) as Array<keyof DocumentData['fields']>).forEach((key) => {
    const value = result[key];
    if (typeof value === 'string' && value.includes('undefined')) {
      // @ts-ignore
      result[key] = null;
    }
  });

  return result;
}

export function reverseProfileDocumentDataInfoFieldsMapperWithNumberOnly(formInfo: {
  [key: string]: string;
}): DocumentData['fields'] {
  const result: DocumentData['fields'] = {};

  if (formInfo.serialNumberDoc) {
    result.referenceNumber = formInfo.serialNumberDoc;
  }

  if (formInfo.date) {
    result.dateIssue = formInfo.date;
  }

  if (formInfo.auth_dep) {
    result.issue = formInfo.auth_dep;
  }

  if (formInfo.unzr) {
    result.unzr = formInfo.unzr;
  }

  if (formInfo.expirationDate) {
    result.expiredDate = formInfo.expirationDate;
  }

  if (formInfo.issueCountryIso2) {
    result.issueCountryIso2 = formInfo.issueCountryIso2;
  }

  (Object.keys(result) as Array<keyof DocumentData['fields']>).forEach((key) => {
    const value = result[key];
    if (typeof value === 'string' && value.includes('undefined')) {
      // @ts-ignore
      result[key] = null;
    }
  });

  return result;
}

export function getId(value: unknown): string {
  if (!value) return '';
  return typeof value === 'object' && 'id' in value ? String(value.id) : String(value);
}

export function excludeEmptyFields(data: Record<string, unknown>): Record<string, string> {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if ((typeof value === 'string' && value.trim().length === 0) || !value) return acc;

    return {
      ...acc,
      [key]: value,
    };
  }, {});
}
